module.exports = __webpack_public_path__ + "img/logo_standard.21846ce8.png";